import { Component } from '@angular/core';
import {GrafanaEmbedComponent} from '../../grafana/grafana-embed';

@Component({
  selector: 'app-overview',
  imports: [GrafanaEmbedComponent],
  templateUrl: './overview.html',
  styleUrl: './overview.scss',
})
export class OverviewComponent {
  grafanaOverview =
    'https://rd.vigimare.simavi.ro/grafana/d/vigimare-operational-overview/vigimare-operational-overview' +
    '?orgId=1' +
    '&kiosk' +
    '&from=now-6h' +
    '&to=now' +
    '&refresh=30s';
}
